import React, { useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import HelpIcon from "@mui/icons-material/Help";

// Custom.
import AccountIcon from "@vocollege/components/dist/AccountIcon";
import VoLogo from "@vocollege/components/dist/VoLogo";
import LogoSvg from "@vocollege/theme/dist/images/vocollege.svg";
import LogoWhiteSvg from "@vocollege/theme/dist/images/vocollege_white.svg";
import { useStyles } from "./styles";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { VoAppContext } from "services/GlobalState";
import VoHelp from "@vocollege/components/dist/VoHelp";

const Header: React.FC = () => {
  const classes = useStyles();
  const { state, dispatch } = useContext<any>(VoAppContext);

  return (
    <>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <Link to="/" className={classes.logoWrapper}>
            <VoLogo color="white" src={LogoSvg} srcWhite={LogoWhiteSvg} />
          </Link>
          <Typography variant="h6" noWrap>
            Diplom och intyg
          </Typography>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <Button
              disableElevation
              component={Link}
              to="/"
              color="inherit"
              variant="outlined"
              // color={VoRouter.pathIsActive("/") ? "secondary" : "inherit"}
              // variant={VoRouter.pathIsActive("/") ? "contained" : "outlined"}
              startIcon={<DashboardIcon />}
              className={classes.menuButton}
            >
              {I18n.get.misc.start}
            </Button>
            {/* {VoAuth.ability.can("access_statistics", "Cert") && (
              <Button
                disableElevation
                component={Link}
                to="/statistik"
                color={
                  VoRouter.pathIsActive("/statistik") ? "secondary" : "inherit"
                }
                variant={
                  VoRouter.pathIsActive("/statistik") ? "contained" : "outlined"
                }
                startIcon={<BarChartIcon />}
                className={classes.menuButton}
              >
                {I18n.get.statistics.labels.statistics}
              </Button>
            )} */}
            <AccountIcon className={classes.menuButton} />
            <Button
              disableElevation
              className={classes.menuButton}
              color={state.openHelp ? "secondary" : "inherit"}
              variant={state.openHelp ? "contained" : "outlined"}
              startIcon={<HelpIcon />}
              onClick={() =>
                dispatch({ key: "openHelp", values: !state.openHelp })
              }
            >
              {I18n.get.help.labels.help}
            </Button>
          </div>
        </Toolbar>
      </AppBar>
      <VoHelp
        open={state.openHelp}
        onClose={() => dispatch({ key: "openHelp", values: false })}
        settingName="vocertDefaultHelpBook"
      />
    </>
  );
};

export default Header;
